export default __webpack_public_path__ + "static/media/img8.9b257687.jpg";